import React from "react";

import "./index.scss";
import { CardProps } from "models/Card";

const Card = ({ img, title, subtitle = "", onClickAction }: CardProps) => {
  return (
    <div
      className="card"
      style={img ? { backgroundImage: `url(${img})` } : {}}
      onClick={onClickAction}
    >
      {title && <h2 className="heading-1">{title}</h2>}
      <p className="heading-5">{subtitle}</p>
      <p className="body underline">Discover more</p>
    </div>
  );
};

export default Card;
